import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

export const SolidContent = styled.div`
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  height: 100%;
  position: relative;

  @media not screen and ${plume.BREAKPOINTS.TABLET} {
    z-index: 1;
  }
`

export const Form = styled.form<{ multiplier?: number }>`
  height: ${({ multiplier }) => `calc(100% - (132px + ${multiplier ?? 2} * 22px))`};

  @media screen and (max-height: 740px) {
    height: unset;
  }

  ${plume.RadioGroupField} {
    margin-left: auto;
    margin-right: auto;
  }

  ${plume.RadioField} {
    margin-bottom: 16px;

    &:is(:last-child) {
      margin-bottom: 0;
    }

    ${plume.Field} {
      padding-right: 75px;
    }
  }
`
